import { render } from "./FactorFoodCard.vue?vue&type=template&id=05abb19e"
import script from "./FactorFoodCard.vue?vue&type=script&lang=js"
export * from "./FactorFoodCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__